var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginGraphic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 820,
    height: 730,
    viewBox: "0 0 820 730",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M601.5 488C601.5 518.676 580.126 546.54 545.367 566.764C510.62 586.98 462.585 599.5 409.5 599.5C356.415 599.5 308.38 586.98 273.633 566.764C238.874 546.54 217.5 518.676 217.5 488C217.5 457.324 238.874 429.46 273.633 409.236C308.38 389.02 356.415 376.5 409.5 376.5C462.585 376.5 510.62 389.02 545.367 409.236C580.126 429.46 601.5 457.324 601.5 488Z",
    stroke: "white",
    strokeOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M703.5 488C703.5 534.968 670.71 577.582 617.492 608.483C564.287 639.376 490.752 658.5 409.5 658.5C328.248 658.5 254.713 639.376 201.508 608.483C148.29 577.582 115.5 534.968 115.5 488C115.5 441.032 148.29 398.418 201.508 367.517C254.713 336.624 328.248 317.5 409.5 317.5C490.752 317.5 564.287 336.624 617.492 367.517C670.71 398.418 703.5 441.032 703.5 488Z",
    stroke: "white",
    strokeOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_4622_3085)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 368,
    cy: 430.5,
    rx: 248,
    ry: 115.5,
    fill: "#685FD3"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M252.381 338.087L238.787 345.936L176 309.686L189.594 301.837L252.381 338.087Z",
    fill: "url(#paint0_linear_4622_3085)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M258.334 394.777L229.077 377.888L252.326 364.465L281.583 381.354L258.334 394.777Z",
    fill: "#041860"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M259.479 401.129L218.073 377.227L251.181 358.113L292.586 382.015L259.479 401.129ZM220.073 377.227L259.479 399.975L290.586 382.015L251.181 359.267L220.073 377.227Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M258.334 355.719L229.077 338.83L252.326 325.407L281.583 342.297L258.334 355.719Z",
    fill: "url(#paint1_linear_4622_3085)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M281.583 360.415V342.297L258.334 355.719V373.838L281.583 360.415Z",
    fill: "url(#paint2_linear_4622_3085)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M229.077 338.83V356.948L258.334 373.838V355.719L229.077 338.83Z",
    fill: "url(#paint3_linear_4622_3085)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M247.067 334.592L234.402 341.904V345.824L238.16 347.995V344.075L250.826 336.762L247.067 334.592Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M255.113 339.234L242.447 346.546V350.466L246.206 352.636V348.716L258.872 341.404L255.113 339.234Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M263.167 343.884L250.502 351.197V355.117L254.26 357.287V353.367L266.926 346.054L263.167 343.884Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M247.067 334.592V336.171L249.482 337.538L250.826 336.762L247.067 334.592Z",
    fill: "#A9EBFF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M235.764 345.014L234.402 345.824L238.16 347.995V346.363L235.764 345.014Z",
    fill: "#A9EBFF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M247.067 334.592L234.402 341.904V345.824L235.764 345.014V342.7L247.073 336.171L247.067 334.592Z",
    fill: "url(#paint4_linear_4622_3085)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M255.113 339.234V340.813L257.528 342.18L258.872 341.404L255.113 339.234Z",
    fill: "#A9EBFF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M243.809 349.656L242.447 350.466L246.206 352.636V351.005L243.809 349.656Z",
    fill: "#A9EBFF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M255.113 339.234L242.447 346.546V350.466L243.809 349.656V347.342L255.119 340.813L255.113 339.234Z",
    fill: "url(#paint5_linear_4622_3085)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M263.167 343.884V345.463L265.582 346.83L266.926 346.054L263.167 343.884Z",
    fill: "#A9EBFF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M251.864 354.306L250.502 355.117L254.26 357.287V355.655L251.864 354.306Z",
    fill: "#A9EBFF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M263.167 343.884L250.502 351.197V355.117L251.864 354.306V351.993L263.174 345.463L263.167 343.884Z",
    fill: "url(#paint6_linear_4622_3085)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M410.24 554.944C375.925 554.944 341.62 547.405 315.496 532.322C290.094 517.656 276.104 498.128 276.104 477.333C276.104 456.538 290.092 437.011 315.493 422.346C367.732 392.184 452.735 392.186 504.978 422.348C530.38 437.014 544.37 456.542 544.37 477.337C544.37 498.131 530.382 517.658 504.981 532.323C478.864 547.402 444.548 554.944 410.24 554.944ZM410.233 400.71C376.103 400.71 341.975 408.21 315.993 423.211C290.916 437.69 277.104 456.911 277.104 477.333C277.104 497.755 290.917 516.976 315.996 531.457C367.964 561.46 452.518 561.457 504.481 531.458C529.558 516.978 543.37 497.759 543.37 477.337C543.37 456.915 529.557 437.693 504.478 423.213C478.495 408.212 444.363 400.71 410.233 400.71Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M410.237 532.647C463.149 532.647 506.042 507.883 506.042 477.334C506.042 446.786 463.149 422.021 410.237 422.021C357.325 422.021 314.432 446.786 314.432 477.334C314.432 507.883 357.325 532.647 410.237 532.647Z",
    fill: "#041860"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M471.246 262.451L373.16 205.773C371.578 204.86 370.131 204.785 369.008 205.395L362.35 209.278L366.701 211.905V441.723C366.701 446.479 369.593 452.004 373.16 454.064L470.11 510.086L468.728 515.006L475.438 511.101L475.43 511.099C476.82 510.322 477.705 508.485 477.705 505.859V274.792C477.705 270.036 474.813 264.51 471.246 262.451Z",
    fill: "url(#paint7_linear_4622_3085)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M464.438 514.704L366.352 458.026C362.785 455.967 359.893 450.441 359.893 445.685V214.617C359.893 209.861 362.785 207.675 366.352 209.734L464.438 266.412C468.005 268.472 470.897 273.997 470.897 278.753V509.821C470.897 514.577 468.005 516.763 464.438 514.704Z",
    fill: "url(#paint8_linear_4622_3085)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M470.897 509.982L359.893 445.845V214.456L470.897 278.593V509.982Z",
    fill: "#0F65B2"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M453.166 514.425L354.093 457.182C350.378 455.035 348.089 451.07 348.089 446.779V229.171C348.089 226.129 351.383 224.228 354.017 225.75L453.09 282.993C456.805 285.14 459.094 289.105 459.094 293.396V511.005C459.094 514.046 455.8 515.947 453.166 514.425Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M455.142 515.399C454.388 515.399 453.635 515.201 452.948 514.804L353.875 457.561C350.037 455.343 347.653 451.212 347.653 446.78V229.171C347.653 227.584 348.474 226.163 349.848 225.37C351.221 224.576 352.861 224.578 354.236 225.371L453.309 282.613C457.147 284.831 459.532 288.962 459.532 293.394V511.003C459.532 512.59 458.711 514.011 457.337 514.804C456.65 515.201 455.896 515.399 455.142 515.399ZM453.386 514.047C454.486 514.684 455.8 514.683 456.9 514.048C458 513.412 458.658 512.275 458.658 511.004V293.395C458.658 289.274 456.441 285.433 452.873 283.372L353.8 226.13C352.701 225.494 351.386 225.493 350.287 226.128C349.186 226.763 348.529 227.901 348.529 229.172V446.781C348.529 450.902 350.745 454.743 354.313 456.804L453.386 514.047Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M422.728 247.772L408.063 239.305C407.565 239.018 407.161 238.246 407.161 237.582C407.161 236.918 407.565 236.613 408.063 236.901L422.728 245.368C423.226 245.655 423.63 246.427 423.63 247.091C423.629 247.755 423.226 248.06 422.728 247.772Z",
    fill: "#0063AD"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M428.756 379.108C430.764 380.268 432.392 379.037 432.392 376.359V296.005C432.392 293.327 430.764 290.217 428.756 289.057L348.399 242.663C348.199 243.589 348.09 244.557 348.09 245.563V332.535L428.756 379.108Z",
    fill: "#041860"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M368.372 349.329L368.389 351.324C366.676 350.527 364.494 350.168 361.911 350.357C352.817 351.022 342.226 358.215 338.255 366.423C337.156 368.696 336.681 370.807 336.76 372.659L334.918 372.05L336.902 374.972L336.905 374.964C338.552 377.526 341.899 378.95 346.533 378.611C355.627 377.946 366.218 370.753 370.188 362.545C372.173 358.441 372.128 354.86 370.449 352.389L368.372 349.329Z",
    fill: "#F4A856"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M358.215 370.368C367.454 364.095 372.007 354.685 368.385 349.351C364.763 344.017 354.337 344.779 345.098 351.053C335.86 357.326 331.307 366.736 334.929 372.07C338.551 377.404 348.977 376.642 358.215 370.368Z",
    fill: "#FCCC6B"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M368.111 359.485C364.14 367.693 353.549 374.886 344.455 375.551C335.361 376.216 331.208 370.102 335.179 361.894C339.15 353.686 349.741 346.493 358.834 345.828C367.929 345.162 372.082 351.277 368.111 359.485Z",
    fill: "url(#paint9_radial_4622_3085)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M357.354 368.857C353.706 371.358 349.5 373.053 345.622 373.337C341.865 373.612 338.968 372.541 337.461 370.323C335.955 368.104 336.028 365.016 337.668 361.626C341.02 354.699 349.992 348.604 357.669 348.043C361.426 347.768 364.323 348.839 365.83 351.057C367.336 353.276 367.263 356.364 365.623 359.754C363.964 363.181 360.928 366.407 357.354 368.857ZM346.127 352.8C342.603 355.217 339.611 358.394 337.976 361.775C336.391 365.05 336.309 368.017 337.744 370.13C339.179 372.243 341.968 373.261 345.597 372.996C353.166 372.442 362.009 366.435 365.315 359.603C366.9 356.328 366.982 353.361 365.547 351.248C364.112 349.135 361.324 348.118 357.695 348.383C353.872 348.663 349.722 350.335 346.127 352.8Z",
    fill: "#F4A856"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M365.469 359.678C362.136 366.569 353.244 372.607 345.61 373.166C337.976 373.725 334.489 368.591 337.822 361.701C341.155 354.81 350.047 348.772 357.681 348.213C365.316 347.654 368.802 352.788 365.469 359.678Z",
    fill: "url(#paint10_radial_4622_3085)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M338.278 362.373C341.612 355.482 350.503 349.444 358.137 348.885C361.748 348.621 364.429 349.631 365.902 351.498C364.574 349.206 361.704 347.919 357.681 348.213C350.047 348.772 341.155 354.81 337.822 361.701C336.065 365.332 336.205 368.474 337.845 370.554C336.653 368.497 336.702 365.632 338.278 362.373Z",
    fill: "#F4A856"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M367.678 358.848C363.707 367.056 353.116 374.249 344.023 374.914C339.671 375.232 336.455 373.995 334.715 371.722C336.319 374.398 339.713 375.898 344.456 375.551C353.55 374.886 364.141 367.693 368.112 359.485C370.183 355.205 370.04 351.497 368.144 349.02C369.614 351.475 369.579 354.92 367.678 358.848Z",
    fill: "#FCE586"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M365.343 369.193C367.368 367.143 369.055 364.888 370.189 362.544C372.174 358.44 372.129 354.859 370.45 352.388L368.372 349.329C368.343 349.287 368.305 349.251 368.275 349.209C368.23 349.146 368.189 349.081 368.143 349.02C368.156 349.041 368.163 349.065 368.176 349.086C366.446 346.776 363.224 345.507 358.835 345.828C353.688 346.205 348.064 348.674 343.43 352.233L359.804 369.194H365.343V369.193Z",
    fill: "#F4A856"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M418.352 295.687L301.726 228.353C300.817 227.828 299.988 227.797 299.35 228.165L299.351 228.16L297.617 229.172C297.617 229.172 298.017 229.23 298.42 229.285C298.21 229.777 298.09 230.386 298.09 231.103V311.457C298.09 314.135 299.718 317.245 301.726 318.405L418.352 385.739C418.572 385.866 418.787 385.959 418.996 386.03V386.941L420.738 385.926H420.728C421.498 385.482 421.988 384.454 421.988 382.989V302.635C421.989 299.957 420.361 296.847 418.352 295.687Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M416.662 386.724L300.036 319.39C298.028 318.23 296.4 315.12 296.4 312.442V232.088C296.4 229.41 298.028 228.179 300.036 229.339L416.662 296.673C418.67 297.833 420.298 300.943 420.298 303.621V383.975C420.298 386.653 418.67 387.884 416.662 386.724Z",
    fill: "url(#paint11_linear_4622_3085)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M381.85 300.844V289.374L384.284 290.779C384.743 291.044 385.142 291.322 385.484 291.613C385.826 291.906 386.13 292.238 386.395 292.61C386.661 292.982 386.861 293.401 386.998 293.867C387.133 294.333 387.199 294.84 387.194 295.385C387.191 296.798 386.704 297.308 385.733 296.913C386.32 297.382 386.758 297.931 387.049 298.561C387.338 299.192 387.484 299.928 387.489 300.77C387.492 301.86 387.257 302.551 386.782 302.842C386.306 303.133 385.613 303.014 384.702 302.488L381.85 300.844ZM383.66 295.096L384.223 295.42C384.754 295.727 385.12 295.807 385.319 295.659C385.519 295.512 385.619 295.127 385.619 294.504C385.619 294.181 385.586 293.9 385.52 293.661C385.455 293.424 385.343 293.207 385.187 293.015C385.032 292.825 384.859 292.658 384.67 292.517C384.48 292.374 384.228 292.212 383.911 292.03L383.66 291.885V295.096ZM383.66 300.415L384.325 300.799C384.865 301.111 385.237 301.181 385.445 301.01C385.653 300.84 385.757 300.42 385.757 299.751C385.757 299.059 385.641 298.49 385.407 298.044C385.173 297.598 384.781 297.216 384.229 296.898L383.66 296.569V300.415Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M388.135 304.473L390.154 294.168L392.042 295.258L394.055 307.89L392.371 306.918L391.97 304.023L390.25 303.03L389.843 305.459L388.135 304.473ZM390.442 301.777L391.771 302.545L391.107 297.451L390.442 301.777Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M395.031 308.453V296.984L396.278 297.703L398.71 305.603V299.107L400.208 299.972V311.442L399.022 310.758L396.566 302.512V309.34L395.031 308.453Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M401.694 312.301V300.83L403.504 301.875V306.856L405.456 303.002L407.182 303.998L405.284 308.034L407.381 315.582L405.577 314.541L403.864 308.155L403.505 308.695V313.344L401.694 312.301Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M328.6 319.216L306.461 306.434V303.476L328.6 316.258V319.216Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M355.812 334.927L333.674 322.145V319.187L355.812 331.969V334.927Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M383.025 350.637L360.886 337.855V334.897L383.025 347.678V350.637Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M410.237 366.348L388.098 353.566V350.608L410.237 363.39V366.348Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M416.662 296.673L300.036 229.339C298.028 228.179 296.4 229.41 296.4 232.088V312.442C296.4 312.931 296.47 313.434 296.572 313.938C302.777 309.452 328.006 295.58 376.202 322.169C393.748 331.849 408.419 330.569 420.299 324.231V303.621C420.298 300.943 418.67 297.833 416.662 296.673Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M344.743 292.586C361.112 290.476 374.806 285.461 386.174 279.071L300.036 229.339C298.028 228.179 296.4 229.41 296.4 232.088V308.988C304.998 302.206 319.704 295.814 344.743 292.586Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M371.219 487.038L370.104 488.693C369.142 487.067 367.545 485.536 365.309 484.232C357.433 479.638 344.63 479.58 336.714 484.104C334.522 485.357 332.937 486.83 331.954 488.402L330.779 486.858L330.763 490.39L330.77 490.385C330.68 493.429 332.634 496.497 336.648 498.838C344.524 503.432 357.327 503.49 365.243 498.966C369.201 496.704 371.189 493.725 371.202 490.737L371.219 487.038Z",
    fill: "#F4A856"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M371.226 487.038C371.255 480.591 362.226 475.324 351.058 475.273C339.891 475.223 330.815 480.409 330.786 486.856C330.757 493.304 339.786 498.571 350.953 498.621C362.121 498.672 371.197 493.486 371.226 487.038Z",
    fill: "#FCCC6B"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M365.26 495.267C357.343 499.791 344.541 499.733 336.665 495.139C328.789 490.545 328.822 483.153 336.738 478.629C344.655 474.105 357.457 474.163 365.333 478.757C373.209 483.352 373.176 490.743 365.26 495.267Z",
    fill: "url(#paint12_radial_4622_3085)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M351.087 496.913C346.664 496.913 342.237 495.932 338.878 493.973C335.625 492.075 333.84 489.553 333.852 486.871C333.864 484.189 335.672 481.683 338.941 479.815C345.623 475.997 356.469 476.045 363.118 479.924C366.371 481.822 368.156 484.343 368.144 487.025C368.132 489.707 366.324 492.213 363.055 494.081C359.749 495.97 355.421 496.913 351.087 496.913ZM350.91 477.321C346.637 477.321 342.373 478.25 339.112 480.113C335.953 481.917 334.207 484.318 334.195 486.872C334.184 489.427 335.908 491.843 339.05 493.677C345.606 497.5 356.296 497.548 362.886 493.783C366.045 491.979 367.791 489.578 367.803 487.023C367.814 484.469 366.09 482.053 362.948 480.22C359.636 478.289 355.269 477.321 350.91 477.321Z",
    fill: "#F4A856"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M362.971 493.932C356.325 497.73 345.577 497.682 338.965 493.825C332.353 489.968 332.38 483.763 339.026 479.965C345.672 476.167 356.42 476.215 363.032 480.072C369.645 483.929 369.617 490.134 362.971 493.932Z",
    fill: "url(#paint13_radial_4622_3085)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M339.023 480.777C345.669 476.979 356.417 477.027 363.029 480.884C366.156 482.708 367.796 485.058 367.955 487.43C368.156 484.789 366.517 482.104 363.032 480.071C356.42 476.214 345.672 476.166 339.026 479.964C335.524 481.965 333.862 484.635 334.038 487.278C334.219 484.908 335.879 482.573 339.023 480.777Z",
    fill: "#F4A856"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M365.263 494.497C357.346 499.021 344.544 498.963 336.668 494.369C332.899 492.17 330.946 489.331 330.797 486.472C330.606 489.586 332.558 492.742 336.665 495.138C344.541 499.732 357.344 499.79 365.26 495.266C369.388 492.907 371.368 489.768 371.205 486.653C371.029 489.511 369.051 492.332 365.263 494.497Z",
    fill: "#FCE586"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M374.69 482.084L373.575 483.739C372.613 482.113 371.016 480.582 368.78 479.278C360.904 474.684 348.101 474.627 340.185 479.15C337.993 480.403 336.408 481.876 335.425 483.448L334.25 481.904L334.234 485.436L334.241 485.431C334.15 488.475 336.105 491.543 340.119 493.884C347.995 498.478 360.798 498.536 368.714 494.012C372.672 491.75 374.66 488.771 374.673 485.784L374.69 482.084Z",
    fill: "#F4A856"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M374.697 482.084C374.726 475.637 365.697 470.369 354.53 470.319C343.363 470.269 334.286 475.455 334.257 481.902C334.228 488.35 343.258 493.617 354.425 493.667C365.592 493.717 374.668 488.532 374.697 482.084Z",
    fill: "#FCCC6B"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M368.731 490.313C360.814 494.837 348.012 494.779 340.136 490.185C332.26 485.591 332.293 478.199 340.209 473.676C348.126 469.152 360.928 469.21 368.804 473.804C376.68 478.398 376.647 485.789 368.731 490.313Z",
    fill: "url(#paint14_radial_4622_3085)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M354.558 491.959C350.135 491.959 345.708 490.978 342.349 489.019C339.096 487.121 337.311 484.599 337.323 481.917C337.335 479.235 339.143 476.729 342.412 474.861C349.094 471.043 359.94 471.091 366.589 474.97C369.842 476.868 371.627 479.389 371.615 482.071C371.603 484.753 369.795 487.259 366.526 489.127C363.22 491.016 358.892 491.959 354.558 491.959ZM354.381 472.367C350.108 472.367 345.844 473.296 342.583 475.159C339.424 476.963 337.678 479.364 337.666 481.918C337.655 484.473 339.379 486.889 342.521 488.723C349.077 492.546 359.767 492.594 366.357 488.829C369.516 487.025 371.262 484.624 371.274 482.069C371.285 479.515 369.561 477.099 366.419 475.266C363.107 473.335 358.74 472.367 354.381 472.367Z",
    fill: "#F4A856"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M366.442 488.978C359.796 492.776 349.048 492.728 342.436 488.871C335.824 485.014 335.851 478.809 342.497 475.011C349.143 471.213 359.891 471.261 366.503 475.118C373.116 478.975 373.088 485.18 366.442 488.978Z",
    fill: "url(#paint15_radial_4622_3085)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M342.494 475.823C349.14 472.025 359.888 472.074 366.5 475.93C369.628 477.754 371.267 480.104 371.426 482.476C371.627 479.835 369.988 477.15 366.503 475.117C359.891 471.26 349.143 471.212 342.497 475.01C338.995 477.011 337.332 479.681 337.509 482.324C337.69 479.954 339.35 477.619 342.494 475.823Z",
    fill: "#F4A856"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M368.734 489.544C360.817 494.068 348.015 494.01 340.139 489.416C336.37 487.217 334.417 484.378 334.267 481.519C334.076 484.633 336.028 487.79 340.135 490.185C348.011 494.779 360.814 494.837 368.73 490.313C372.858 487.954 374.838 484.815 374.675 481.7C374.5 484.558 372.522 487.379 368.734 489.544Z",
    fill: "#FCE586"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M401.335 506.707L400.22 508.362C399.258 506.736 397.661 505.205 395.425 503.901C387.549 499.307 374.746 499.249 366.83 503.773C364.638 505.026 363.053 506.499 362.07 508.071L360.895 506.527L360.879 510.059L360.886 510.054C360.795 513.098 362.75 516.166 366.764 518.507C374.64 523.101 387.443 523.159 395.359 518.635C399.317 516.373 401.305 513.394 401.318 510.406L401.335 506.707Z",
    fill: "#F4A856"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M395.376 514.935C387.459 519.459 374.657 519.401 366.781 514.807C358.905 510.213 358.938 502.821 366.854 498.298C374.771 493.774 387.573 493.832 395.449 498.426C403.326 503.02 403.293 510.412 395.376 514.935Z",
    fill: "#FCCC6B"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M395.376 514.935C387.459 519.459 374.657 519.401 366.781 514.807C358.905 510.213 358.938 502.821 366.854 498.298C374.771 493.774 387.573 493.832 395.449 498.426C403.326 503.02 403.293 510.412 395.376 514.935Z",
    fill: "url(#paint16_radial_4622_3085)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M381.204 516.582C376.781 516.582 372.354 515.601 368.995 513.642C365.741 511.744 363.957 509.222 363.969 506.54C363.981 503.858 365.788 501.352 369.058 499.484C375.74 495.666 386.586 495.714 393.235 499.593C396.489 501.491 398.273 504.012 398.261 506.694C398.249 509.376 396.441 511.882 393.172 513.75C389.866 515.639 385.537 516.582 381.204 516.582ZM381.027 496.99C376.754 496.99 372.49 497.919 369.228 499.782C366.069 501.586 364.323 503.987 364.312 506.541C364.3 509.096 366.025 511.512 369.167 513.346C375.723 517.169 386.413 517.217 393.003 513.452C396.162 511.648 397.908 509.247 397.919 506.692C397.931 504.138 396.206 501.722 393.064 499.889C389.753 497.958 385.385 496.99 381.027 496.99Z",
    fill: "#F4A856"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M393.088 513.6C386.442 517.398 375.694 517.35 369.082 513.493C362.47 509.636 362.497 503.431 369.144 499.633C375.791 495.835 386.538 495.883 393.15 499.74C399.761 503.597 399.734 509.803 393.088 513.6Z",
    fill: "url(#paint17_radial_4622_3085)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M369.139 500.446C375.785 496.648 386.533 496.697 393.145 500.553C396.273 502.377 397.912 504.727 398.071 507.099C398.272 504.458 396.633 501.773 393.149 499.74C386.537 495.883 375.789 495.835 369.143 499.633C365.641 501.634 363.978 504.305 364.155 506.947C364.335 504.577 365.996 502.242 369.139 500.446Z",
    fill: "#F4A856"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M395.38 514.166C387.463 518.69 374.661 518.632 366.785 514.038C363.016 511.839 361.063 509 360.913 506.141C360.722 509.255 362.674 512.412 366.781 514.807C374.657 519.401 387.46 519.459 395.376 514.935C399.504 512.576 401.484 509.437 401.321 506.322C401.146 509.18 399.168 512.001 395.38 514.166Z",
    fill: "#FCE586"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M360.9 513.72L359.785 515.375C358.823 513.749 357.226 512.218 354.99 510.914C347.114 506.32 334.311 506.263 326.395 510.786C324.203 512.039 322.618 513.512 321.635 515.084L320.46 513.54L320.444 517.072L320.451 517.067C320.36 520.111 322.315 523.179 326.329 525.52C334.205 530.114 347.008 530.172 354.924 525.648C358.882 523.386 360.87 520.407 360.883 517.42L360.9 513.72Z",
    fill: "#F4A856"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M354.941 521.948C347.024 526.472 334.222 526.414 326.346 521.82C318.47 517.226 318.503 509.834 326.419 505.311C334.336 500.787 347.138 500.845 355.014 505.439C362.891 510.033 362.858 517.425 354.941 521.948Z",
    fill: "#FCCC6B"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M354.941 521.948C347.024 526.472 334.222 526.414 326.346 521.82C318.47 517.226 318.503 509.834 326.419 505.311C334.336 500.787 347.138 500.845 355.014 505.439C362.891 510.033 362.858 517.425 354.941 521.948Z",
    fill: "url(#paint18_radial_4622_3085)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M340.769 523.594C336.346 523.594 331.919 522.613 328.56 520.654C325.306 518.756 323.522 516.234 323.534 513.552C323.546 510.87 325.353 508.364 328.623 506.496C335.305 502.678 346.151 502.726 352.8 506.605C356.054 508.503 357.838 511.024 357.826 513.706C357.814 516.388 356.006 518.894 352.737 520.762C349.431 522.651 345.102 523.594 340.769 523.594ZM340.592 504.002C336.319 504.002 332.055 504.931 328.793 506.794C325.634 508.598 323.888 510.999 323.877 513.553C323.865 516.108 325.59 518.524 328.732 520.358C335.288 524.181 345.978 524.229 352.568 520.464C355.727 518.66 357.473 516.259 357.485 513.704C357.497 511.15 355.772 508.734 352.63 506.901C349.318 504.97 344.95 504.002 340.592 504.002Z",
    fill: "#F4A856"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M352.653 520.613C346.007 524.411 335.259 524.363 328.647 520.506C322.035 516.649 322.062 510.444 328.709 506.646C335.355 502.848 346.103 502.896 352.715 506.753C359.326 510.61 359.299 516.816 352.653 520.613Z",
    fill: "url(#paint19_radial_4622_3085)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M328.704 507.459C335.35 503.661 346.098 503.71 352.71 507.566C355.838 509.39 357.477 511.74 357.636 514.112C357.837 511.471 356.198 508.786 352.714 506.753C346.102 502.896 335.354 502.848 328.708 506.646C325.206 508.647 323.543 511.318 323.72 513.96C323.9 511.59 325.561 509.255 328.704 507.459Z",
    fill: "#F4A856"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M354.945 521.178C347.028 525.702 334.226 525.644 326.35 521.05C322.581 518.851 320.628 516.012 320.478 513.153C320.287 516.267 322.239 519.424 326.346 521.819C334.222 526.413 347.025 526.471 354.941 521.947C359.069 519.588 361.049 516.449 360.886 513.334C360.711 516.192 358.733 519.013 354.945 521.178Z",
    fill: "#FCE586"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M380.031 506.284L378.916 507.939C377.954 506.313 376.357 504.782 374.121 503.477C366.245 498.883 353.442 498.826 345.526 503.349C343.334 504.602 341.749 506.075 340.766 507.647L339.591 506.103L339.575 509.635L339.582 509.63C339.491 512.674 341.446 515.742 345.46 518.083C353.336 522.677 366.139 522.735 374.055 518.211C378.013 515.949 380.001 512.97 380.014 509.983L380.031 506.284Z",
    fill: "#F4A856"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M380.039 506.284C380.068 499.837 371.039 494.57 359.872 494.519C348.704 494.469 339.628 499.655 339.599 506.102C339.57 512.55 348.599 517.817 359.766 517.867C370.934 517.918 380.01 512.732 380.039 506.284Z",
    fill: "#FCCC6B"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M374.072 514.512C366.155 519.036 353.353 518.978 345.477 514.384C337.601 509.79 337.634 502.398 345.55 497.875C353.467 493.351 366.269 493.409 374.145 498.003C382.021 502.597 381.988 509.989 374.072 514.512Z",
    fill: "url(#paint20_radial_4622_3085)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M359.9 516.16C355.477 516.16 351.049 515.179 347.691 513.22C344.437 511.322 342.653 508.8 342.665 506.118C342.677 503.436 344.485 500.93 347.754 499.062C354.436 495.244 365.282 495.292 371.931 499.171C375.185 501.069 376.969 503.59 376.957 506.272C376.945 508.954 375.137 511.46 371.868 513.328C368.561 515.217 364.233 516.16 359.9 516.16ZM359.722 496.567C355.449 496.567 351.185 497.496 347.923 499.359C344.764 501.163 343.018 503.564 343.007 506.118C342.995 508.673 344.72 511.089 347.862 512.923C354.418 516.746 365.108 516.794 371.698 513.029C374.857 511.225 376.603 508.824 376.614 506.269C376.626 503.715 374.901 501.299 371.759 499.466C368.449 497.535 364.081 496.567 359.722 496.567Z",
    fill: "#F4A856"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M371.783 513.178C365.137 516.976 354.389 516.928 347.777 513.071C341.165 509.214 341.192 503.009 347.838 499.211C354.484 495.413 365.232 495.461 371.844 499.318C378.457 503.175 378.429 509.381 371.783 513.178Z",
    fill: "url(#paint21_radial_4622_3085)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M347.835 500.024C354.481 496.226 365.229 496.274 371.841 500.131C374.969 501.955 376.608 504.305 376.767 506.677C376.968 504.036 375.329 501.351 371.845 499.318C365.233 495.461 354.485 495.413 347.839 499.211C344.337 501.212 342.675 503.882 342.851 506.525C343.031 504.155 344.691 501.82 347.835 500.024Z",
    fill: "#F4A856"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M374.075 513.743C366.158 518.267 353.356 518.209 345.48 513.615C341.711 511.417 339.758 508.577 339.609 505.719C339.418 508.833 341.37 511.99 345.477 514.385C353.353 518.979 366.156 519.037 374.072 514.513C378.2 512.154 380.18 509.015 380.017 505.9C379.841 508.758 377.863 511.579 374.075 513.743Z",
    fill: "#FCE586"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M385.26 502.243L384.145 503.898C383.184 502.272 381.586 500.741 379.35 499.436C371.474 494.842 358.671 494.785 350.755 499.308C348.563 500.561 346.978 502.034 345.995 503.606L344.82 502.062L344.804 505.594L344.811 505.589C344.721 508.633 346.675 511.701 350.689 514.042C358.565 518.636 371.368 518.694 379.284 514.17C383.242 511.908 385.23 508.929 385.243 505.942L385.26 502.243Z",
    fill: "#F4A856"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M385.268 502.243C385.297 495.796 376.267 490.529 365.1 490.478C353.933 490.428 344.857 495.614 344.828 502.061C344.799 508.509 353.828 513.776 364.995 513.826C376.162 513.877 385.239 508.691 385.268 502.243Z",
    fill: "#FCCC6B"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M379.301 510.471C371.385 514.995 358.582 514.937 350.706 510.343C342.83 505.749 342.863 498.357 350.779 493.834C358.696 489.31 371.498 489.368 379.374 493.962C387.25 498.556 387.218 505.947 379.301 510.471Z",
    fill: "url(#paint22_radial_4622_3085)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M365.129 512.118C360.706 512.118 356.279 511.137 352.92 509.178C349.667 507.28 347.882 504.758 347.894 502.076C347.906 499.394 349.714 496.888 352.983 495.02C359.665 491.202 370.511 491.25 377.16 495.129C380.413 497.027 382.198 499.548 382.186 502.23C382.174 504.912 380.366 507.418 377.097 509.286C373.79 511.175 369.462 512.118 365.129 512.118ZM364.951 492.526C360.678 492.526 356.414 493.455 353.153 495.318C349.994 497.122 348.248 499.523 348.236 502.077C348.225 504.632 349.949 507.048 353.091 508.882C359.647 512.705 370.337 512.753 376.927 508.988C380.086 507.184 381.832 504.783 381.844 502.228C381.855 499.674 380.131 497.258 376.989 495.425C373.678 493.494 369.31 492.526 364.951 492.526Z",
    fill: "#F4A856"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M377.012 509.136C370.366 512.934 359.618 512.886 353.006 509.029C346.394 505.172 346.421 498.967 353.068 495.169C359.714 491.371 370.462 491.419 377.074 495.276C383.686 499.133 383.658 505.338 377.012 509.136Z",
    fill: "url(#paint23_radial_4622_3085)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M353.064 495.981C359.71 492.183 370.458 492.231 377.07 496.088C380.198 497.912 381.837 500.262 381.996 502.634C382.197 499.993 380.558 497.308 377.074 495.275C370.462 491.418 359.714 491.37 353.068 495.168C349.566 497.169 347.903 499.839 348.08 502.482C348.26 500.113 349.921 497.778 353.064 495.981Z",
    fill: "#F4A856"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M379.304 509.702C371.387 514.226 358.585 514.168 350.709 509.574C346.94 507.376 344.987 504.536 344.837 501.678C344.646 504.792 346.598 507.949 350.705 510.344C358.581 514.938 371.384 514.996 379.3 510.472C383.428 508.113 385.408 504.974 385.245 501.859C385.071 504.716 383.093 507.538 379.304 509.702Z",
    fill: "#FCE586"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M388.03 494.47L386.915 496.125C385.953 494.499 384.356 492.968 382.12 491.664C374.244 487.07 361.441 487.012 353.525 491.536C351.333 492.789 349.748 494.262 348.765 495.834L347.59 494.29L347.574 497.822L347.581 497.817C347.49 500.861 349.445 503.929 353.459 506.27C361.335 510.864 374.138 510.922 382.054 506.398C386.012 504.136 388 501.157 388.013 498.169L388.03 494.47Z",
    fill: "#F4A856"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M382.071 502.699C374.154 507.223 361.352 507.165 353.476 502.571C345.6 497.977 345.633 490.585 353.549 486.062C361.466 481.538 374.268 481.596 382.144 486.19C390.021 490.784 389.988 498.176 382.071 502.699Z",
    fill: "#FCCC6B"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M382.071 502.699C374.154 507.223 361.352 507.165 353.476 502.571C345.6 497.977 345.633 490.585 353.549 486.062C361.466 481.538 374.268 481.596 382.144 486.19C390.021 490.784 389.988 498.176 382.071 502.699Z",
    fill: "url(#paint24_radial_4622_3085)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M367.899 504.345C363.476 504.345 359.049 503.364 355.69 501.405C352.436 499.507 350.652 496.985 350.664 494.303C350.676 491.621 352.484 489.115 355.753 487.247C362.435 483.429 373.281 483.477 379.93 487.356C383.184 489.254 384.968 491.775 384.956 494.457C384.944 497.139 383.136 499.645 379.867 501.513C376.561 503.402 372.232 504.345 367.899 504.345ZM367.722 484.752C363.449 484.752 359.185 485.681 355.923 487.544C352.764 489.348 351.018 491.749 351.007 494.303C350.995 496.858 352.72 499.274 355.862 501.108C362.418 504.931 373.108 504.979 379.698 501.214C382.857 499.41 384.603 497.009 384.614 494.454C384.626 491.9 382.901 489.484 379.759 487.651C376.448 485.721 372.081 484.752 367.722 484.752Z",
    fill: "#F4A856"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M379.783 501.364C373.137 505.162 362.389 505.114 355.777 501.257C349.165 497.4 349.192 491.195 355.838 487.397C362.484 483.599 373.232 483.647 379.844 487.504C386.456 491.361 386.429 497.567 379.783 501.364Z",
    fill: "url(#paint25_radial_4622_3085)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M355.834 488.21C362.48 484.412 373.228 484.46 379.84 488.317C382.968 490.141 384.607 492.49 384.766 494.862C384.967 492.221 383.328 489.537 379.844 487.504C373.232 483.647 362.484 483.599 355.838 487.397C352.336 489.398 350.673 492.068 350.85 494.711C351.03 492.341 352.691 490.006 355.834 488.21Z",
    fill: "#F4A856"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M382.075 501.929C374.158 506.453 361.356 506.395 353.48 501.801C349.711 499.602 347.758 496.763 347.608 493.904C347.417 497.018 349.369 500.175 353.476 502.57C361.352 507.164 374.155 507.222 382.071 502.698C386.199 500.339 388.179 497.2 388.016 494.085C387.841 496.943 385.863 499.764 382.075 501.929Z",
    fill: "#FCE586"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M402.001 497.688L400.571 499.08C399.963 497.291 398.713 495.466 396.79 493.731C390.021 487.622 377.501 484.945 368.826 487.753C366.424 488.53 364.571 489.648 363.287 490.986L362.453 489.234L361.715 492.688L361.723 492.684C361.011 495.645 362.297 499.048 365.746 502.161C372.515 508.27 385.035 510.947 393.71 508.139C398.048 506.735 400.603 504.226 401.227 501.304L402.001 497.688Z",
    fill: "#F4A856"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M394.484 504.522C385.809 507.329 373.289 504.653 366.52 498.544C359.751 492.435 361.296 485.207 369.971 482.399C378.646 479.592 391.166 482.268 397.935 488.377C404.704 494.486 403.159 501.715 394.484 504.522Z",
    fill: "#FCCC6B"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M394.484 504.522C385.809 507.329 373.289 504.653 366.52 498.544C359.751 492.435 361.296 485.207 369.971 482.399C378.646 479.592 391.166 482.268 397.935 488.377C404.704 494.486 403.159 501.715 394.484 504.522Z",
    fill: "url(#paint26_radial_4622_3085)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M380.275 503.233C375.946 502.328 371.813 500.461 368.926 497.856C366.13 495.332 364.9 492.498 365.46 489.876C366.021 487.254 368.303 485.171 371.886 484.011C379.208 481.642 389.815 483.909 395.529 489.066C398.325 491.59 399.555 494.423 398.995 497.045C398.434 499.667 396.152 501.75 392.569 502.91C388.947 504.082 384.517 504.12 380.275 503.233ZM384.112 484.019C379.929 483.144 375.565 483.181 371.992 484.337C368.531 485.457 366.33 487.449 365.796 489.947C365.262 492.445 366.455 495.163 369.156 497.601C374.79 502.685 385.244 504.92 392.465 502.584C395.926 501.465 398.127 499.472 398.661 496.974C399.195 494.477 398.002 491.759 395.301 489.321C392.455 486.753 388.379 484.911 384.112 484.019Z",
    fill: "#F4A856"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M392.518 502.747C385.235 505.104 374.725 502.857 369.042 497.728C363.359 492.599 364.657 486.531 371.939 484.174C379.222 481.817 389.732 484.064 395.415 489.193C401.097 494.322 399.8 500.39 392.518 502.747Z",
    fill: "url(#paint27_radial_4622_3085)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M371.769 484.969C379.052 482.612 389.562 484.859 395.245 489.988C397.933 492.414 399.057 495.05 398.727 497.404C399.464 494.86 398.41 491.897 395.415 489.194C389.732 484.065 379.222 481.818 371.939 484.175C368.101 485.417 365.928 487.691 365.56 490.313C366.221 488.029 368.324 486.084 371.769 484.969Z",
    fill: "#F4A856"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M394.645 503.769C385.97 506.576 373.45 503.9 366.682 497.791C363.443 494.868 362.112 491.689 362.551 488.86C361.727 491.869 362.991 495.358 366.521 498.544C373.29 504.653 385.81 507.33 394.485 504.522C399.009 503.058 401.589 500.391 402.067 497.308C401.31 500.069 398.796 502.426 394.645 503.769Z",
    fill: "#FCE586"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M371.174 412.59L369.389 413.482C369.353 411.593 368.716 409.475 367.412 407.238C362.819 399.361 351.704 393.008 342.586 393.047C340.061 393.058 337.956 393.56 336.327 394.444L336.065 392.521L334.312 395.587L334.321 395.586C332.743 398.191 332.934 401.823 335.275 405.837C339.868 413.714 350.983 420.066 360.101 420.027C364.66 420.007 367.857 418.393 369.339 415.799L371.174 412.59Z",
    fill: "#F4A856"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M361.936 416.817C352.818 416.856 341.703 410.503 337.11 402.626C332.517 394.749 336.185 388.332 345.303 388.293C354.421 388.254 365.536 394.607 370.129 402.484C374.722 410.36 371.054 416.777 361.936 416.817Z",
    fill: "#FCCC6B"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M361.936 416.817C352.818 416.856 341.703 410.503 337.11 402.626C332.517 394.749 336.185 388.332 345.303 388.293C354.421 388.254 365.536 394.607 370.129 402.484C374.722 410.36 371.054 416.777 361.936 416.817Z",
    fill: "url(#paint28_radial_4622_3085)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M348.79 411.271C344.941 409.093 341.57 406.059 339.611 402.7C337.714 399.446 337.403 396.372 338.733 394.044C340.064 391.716 342.871 390.425 346.637 390.409C354.332 390.376 363.749 395.759 367.627 402.408C369.524 405.662 369.836 408.735 368.506 411.063C367.175 413.391 364.368 414.682 360.602 414.698C356.794 414.715 352.562 413.405 348.79 411.271ZM358.283 394.131C354.564 392.027 350.395 390.736 346.639 390.752C343.001 390.767 340.299 391.997 339.032 394.214C337.764 396.432 338.075 399.384 339.907 402.527C343.73 409.083 353.011 414.388 360.601 414.356C364.239 414.341 366.941 413.111 368.209 410.893C369.476 408.676 369.166 405.724 367.333 402.581C365.402 399.271 362.077 396.278 358.283 394.131Z",
    fill: "#F4A856"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M360.602 414.528C352.948 414.561 343.616 409.227 339.76 402.614C335.904 396.001 338.983 390.614 346.638 390.581C354.293 390.548 363.624 395.882 367.48 402.495C371.336 409.107 368.256 414.495 360.602 414.528Z",
    fill: "url(#paint29_radial_4622_3085)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M346.235 391.286C353.89 391.253 363.221 396.587 367.077 403.2C368.901 406.328 369.171 409.18 368.141 411.323C369.616 409.123 369.512 405.979 367.48 402.494C363.624 395.881 354.293 390.547 346.638 390.58C342.604 390.597 339.843 392.103 338.696 394.49C340.019 392.517 342.614 391.302 346.235 391.286Z",
    fill: "#F4A856"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M362.318 416.148C353.2 416.187 342.085 409.834 337.492 401.957C335.294 398.188 334.992 394.755 336.27 392.193C334.571 394.809 334.715 398.518 337.11 402.625C341.703 410.502 352.818 416.855 361.936 416.816C366.691 416.796 369.959 415.038 371.351 412.247C369.792 414.648 366.681 416.129 362.318 416.148Z",
    fill: "#FCE586"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M367.269 447.963L367.115 449.953C365.477 449.012 363.333 448.468 360.743 448.436C351.626 448.322 340.459 454.585 335.802 462.423C334.512 464.594 333.86 466.657 333.78 468.509L331.996 467.745L333.724 470.825L333.728 470.817C335.15 473.51 338.363 475.215 343.009 475.273C352.126 475.387 363.293 469.125 367.95 461.286C370.279 457.366 370.539 453.795 369.077 451.189L367.269 447.963Z",
    fill: "#F4A856"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M355.329 468.044C365.069 462.582 370.408 453.596 367.255 447.972C364.102 442.349 353.649 442.218 343.909 447.68C334.169 453.142 328.83 462.128 331.983 467.751C335.137 473.375 345.589 473.506 355.329 468.044Z",
    fill: "#FCCC6B"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M366.142 458.059C361.485 465.898 350.318 472.16 341.201 472.046C332.084 471.932 328.468 465.485 333.125 457.647C337.782 449.808 348.949 443.546 358.066 443.66C367.183 443.774 370.799 450.221 366.142 458.059Z",
    fill: "url(#paint30_radial_4622_3085)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M354.624 466.479C350.776 468.66 346.44 469.989 342.552 469.94C338.786 469.893 335.99 468.578 334.678 466.24C333.367 463.901 333.703 460.83 335.627 457.592C339.558 450.976 349.018 445.67 356.715 445.766C360.481 445.813 363.277 447.127 364.589 449.466C365.9 451.805 365.564 454.876 363.64 458.114C361.694 461.388 358.393 464.343 354.624 466.479ZM344.809 449.521C341.091 451.628 337.839 454.538 335.921 457.767C334.062 460.894 333.727 463.844 334.976 466.071C336.226 468.299 338.917 469.551 342.555 469.597C350.144 469.691 359.468 464.462 363.344 457.937C365.203 454.81 365.538 451.86 364.289 449.632C363.04 447.405 360.349 446.153 356.711 446.107C352.879 446.061 348.602 447.372 344.809 449.521Z",
    fill: "#F4A856"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M363.492 458.026C359.582 464.607 350.208 469.864 342.554 469.769C334.9 469.673 331.864 464.261 335.774 457.68C339.684 451.099 349.058 445.842 356.712 445.937C364.367 446.033 367.402 451.446 363.492 458.026Z",
    fill: "url(#paint31_radial_4622_3085)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M336.171 458.389C340.081 451.808 349.455 446.551 357.11 446.646C360.73 446.691 363.316 447.927 364.623 449.912C363.495 447.515 360.746 445.987 356.712 445.937C349.058 445.841 339.683 451.099 335.774 457.68C333.714 461.148 333.584 464.291 335.041 466.502C334.029 464.352 334.322 461.502 336.171 458.389Z",
    fill: "#F4A856"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M365.765 457.388C361.108 465.227 349.941 471.489 340.824 471.375C336.461 471.321 333.362 469.813 331.822 467.4C333.191 470.203 336.445 471.987 341.2 472.047C350.317 472.161 361.484 465.899 366.141 458.06C368.57 453.972 368.744 450.266 367.067 447.636C368.324 450.207 367.994 453.637 365.765 457.388Z",
    fill: "#FCE586"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M247.556 448.063C246.868 448.063 246.18 447.885 245.567 447.532L193.223 417.311C192.923 417.137 192.745 416.828 192.745 416.482C192.745 416.136 192.924 415.827 193.223 415.653L239.517 388.925L239.982 389.732L193.688 416.459L246.032 446.725C246.97 447.267 248.136 447.268 249.076 446.728L280.306 428.761C281.541 428.052 283.071 428.059 284.298 428.776L297.081 436.248L296.612 437.051L283.829 429.579C282.887 429.029 281.716 429.026 280.769 429.568L249.54 447.535C248.928 447.887 248.242 448.063 247.556 448.063Z",
    fill: "white"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M481.494 403.504L432.761 351.175L384.029 347.232C384.029 347.232 376.197 413.294 432.761 483.364C489.326 478.61 481.494 403.504 481.494 403.504Z",
    fill: "url(#paint32_linear_4622_3085)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M384.029 347.232L373.064 353.563L421.796 357.505L432.761 351.175L384.029 347.232Z",
    fill: "url(#paint33_linear_4622_3085)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M470.529 409.834L421.796 357.505L401.758 355.48L373.063 353.562C373.063 353.562 365.231 419.625 421.795 489.695C478.361 484.941 470.529 409.834 470.529 409.834Z",
    fill: "url(#paint34_linear_4622_3085)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M470.529 409.835L421.796 357.506L373.064 353.563C374.441 352.768 374.441 352.768 374.441 352.768L423.822 356.763L472.554 409.092C472.554 409.092 479.092 471.877 436.969 486.265C476.855 470.586 470.529 409.835 470.529 409.835Z",
    fill: "white"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M464.613 410.647L420.798 363.599L402.782 361.778L376.983 360.054C376.983 360.054 369.941 419.45 420.798 482.449C471.654 478.175 464.613 410.647 464.613 410.647Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "hue"
    },
    filter: "url(#filter1_f_4622_3085)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 137,
    y: 184,
    width: 447,
    height: 392,
    fill: "#26114C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4622_3085",
    x: -84,
    y: 111,
    width: 904,
    height: 639,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 102,
    result: "effect1_foregroundBlur_4622_3085"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_4622_3085",
    x: -47,
    y: 0,
    width: 815,
    height: 760,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 92,
    result: "effect1_foregroundBlur_4622_3085"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4622_3085",
    x1: 245.584,
    y1: 342.012,
    x2: 214.484,
    y2: 288.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9EBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0795,
    stopColor: "#8DC6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1856,
    stopColor: "#6D9BCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2973,
    stopColor: "#5176B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4134,
    stopColor: "#3A589D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5355,
    stopColor: "#29418E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6661,
    stopColor: "#1D3183"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8112,
    stopColor: "#15277C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13247A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4622_3085",
    x1: 258.167,
    y1: 342.756,
    x2: 216.618,
    y2: 310.655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59BDEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BDAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4622_3085",
    x1: 258.334,
    y1: 358.067,
    x2: 281.582,
    y2: 358.067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2573BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0063AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4622_3085",
    x1: 229.077,
    y1: 356.334,
    x2: 258.334,
    y2: 356.334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A9BD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2573BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4622_3085",
    x1: 234.401,
    y1: 340.208,
    x2: 247.073,
    y2: 340.208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2573BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0063AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4622_3085",
    x1: 242.447,
    y1: 344.85,
    x2: 255.119,
    y2: 344.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2573BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0063AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4622_3085",
    x1: 250.502,
    y1: 349.5,
    x2: 263.173,
    y2: 349.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2573BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0063AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4622_3085",
    x1: 362.349,
    y1: 360.003,
    x2: 661.873,
    y2: 360.003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A9BD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.522,
    stopColor: "#3088C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#297BBF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4622_3085",
    x1: 337.871,
    y1: 262.995,
    x2: 540.244,
    y2: 366.604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59BDEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BDAFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_4622_3085",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(338.221 361.804) rotate(-51.5165) scale(28.8759 28.8759)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCE586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2273,
    stopColor: "#FCDB7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6161,
    stopColor: "#FCD06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCCC6B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_4622_3085",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(367.167 366.926) rotate(-51.5165) scale(68.6906 68.6906)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCE586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2273,
    stopColor: "#FCDB7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6161,
    stopColor: "#FCD06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCCC6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_4622_3085",
    x1: 296.4,
    y1: 308.032,
    x2: 420.298,
    y2: 308.032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7BDAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59BDEF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_4622_3085",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(339.298 480.275) rotate(-17.0741) scale(28.8757 28.8757)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCE586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2273,
    stopColor: "#FCDB7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6161,
    stopColor: "#FCD06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCCC6B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_4622_3085",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(360.272 500.87) rotate(-17.0741) scale(68.691 68.6909)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCE586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2273,
    stopColor: "#FCDB7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6161,
    stopColor: "#FCD06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCCC6B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_4622_3085",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(342.768 475.32) rotate(-17.0741) scale(28.8757 28.8757)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCE586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2273,
    stopColor: "#FCDB7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6161,
    stopColor: "#FCD06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCCC6B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_4622_3085",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(363.743 495.916) rotate(-17.0741) scale(68.691 68.691)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCE586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2273,
    stopColor: "#FCDB7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6161,
    stopColor: "#FCD06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCCC6B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_4622_3085",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(369.414 499.943) rotate(-17.0741) scale(28.8758 28.8758)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCE586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2273,
    stopColor: "#FCDB7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6161,
    stopColor: "#FCD06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCCC6B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_4622_3085",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(390.388 520.538) rotate(-17.0741) scale(68.691 68.6909)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCE586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2273,
    stopColor: "#FCDB7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6161,
    stopColor: "#FCD06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCCC6B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_4622_3085",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(328.979 506.956) rotate(-17.0741) scale(28.8758 28.8758)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCE586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2273,
    stopColor: "#FCDB7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6161,
    stopColor: "#FCD06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCCC6B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_4622_3085",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(349.953 527.551) rotate(-17.0741) scale(68.6908 68.6908)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCE586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2273,
    stopColor: "#FCDB7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6161,
    stopColor: "#FCD06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCCC6B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_4622_3085",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(348.11 499.52) rotate(-17.0741) scale(28.8758 28.8758)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCE586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2273,
    stopColor: "#FCDB7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6161,
    stopColor: "#FCD06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCCC6B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_4622_3085",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(369.084 520.117) rotate(-17.0741) scale(68.691 68.6909)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCE586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2273,
    stopColor: "#FCDB7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6161,
    stopColor: "#FCD06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCCC6B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_4622_3085",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(353.339 495.479) rotate(-17.0741) scale(28.8757 28.8757)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCE586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2273,
    stopColor: "#FCDB7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6161,
    stopColor: "#FCD06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCCC6B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_4622_3085",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(374.313 516.074) rotate(-17.0741) scale(68.6909 68.691)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCE586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2273,
    stopColor: "#FCDB7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6161,
    stopColor: "#FCD06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCCC6B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_4622_3085",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(356.109 487.707) rotate(-17.0741) scale(28.8758 28.8758)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCE586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2273,
    stopColor: "#FCDB7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6161,
    stopColor: "#FCD06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCCC6B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_4622_3085",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(377.083 508.302) rotate(-17.0741) scale(68.691 68.6909)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCE586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2273,
    stopColor: "#FCDB7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6161,
    stopColor: "#FCD06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCCC6B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_4622_3085",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(372.141 484.533) rotate(-5.26135) scale(28.8757 28.8757)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCE586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2273,
    stopColor: "#FCDB7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6161,
    stopColor: "#FCD06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCCC6B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_4622_3085",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(388.455 508.986) rotate(-5.26134) scale(68.691 68.691)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCE586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2273,
    stopColor: "#FCDB7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6161,
    stopColor: "#FCD06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCCC6B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_4622_3085",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(346.721 390.985) rotate(12.4213) scale(28.8758 28.8758)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCE586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2273,
    stopColor: "#FCDB7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6161,
    stopColor: "#FCD06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCCC6B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_4622_3085",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(354.836 419.238) rotate(12.4213) scale(68.6907 68.6907)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCE586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2273,
    stopColor: "#FCDB7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6161,
    stopColor: "#FCD06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCCC6B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_4622_3085",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(336.163 457.817) rotate(-46.6167) scale(28.8758 28.8758)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCE586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2273,
    stopColor: "#FCDB7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6161,
    stopColor: "#FCD06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCCC6B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_4622_3085",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(364.565 465.393) rotate(-46.6167) scale(68.6908)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCE586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2273,
    stopColor: "#FCDB7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6161,
    stopColor: "#FCD06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCCC6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_4622_3085",
    x1: 418.665,
    y1: 402.598,
    x2: 565.178,
    y2: 447.557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2573BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.907,
    stopColor: "#0364AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0063AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_4622_3085",
    x1: 432.761,
    y1: 352.369,
    x2: 373.064,
    y2: 352.369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0063AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2573BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_4622_3085",
    x1: 372.696,
    y1: 395.251,
    x2: 470.897,
    y2: 395.251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7BDAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59BDEF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginGraphic);
export default __webpack_public_path__ + "static/media/login_graphic.5c8e341ddb2a25097dc4a8cbe3749e17.svg";
export { ForwardRef as ReactComponent };